import { render, staticRenderFns } from "./businessTableHisList.vue?vue&type=template&id=650d2fc6&scoped=true"
import script from "./businessTableHisList.vue?vue&type=script&lang=js"
export * from "./businessTableHisList.vue?vue&type=script&lang=js"
import style0 from "./businessTableHisList.vue?vue&type=style&index=0&id=650d2fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d2fc6",
  null
  
)

export default component.exports